import React from "react";
import Reveal from "./Reveal";
import { Eye, AlertTriangle, Target, FlaskConical, Cpu } from "lucide-react";

/**
 * WhatIs — clear product explanation right after the problem section.
 * Five cards that describe what the user gets, in plain Spanish.
 */
const CARDS = [
  {
    icon: Eye,
    title: "Situación actual",
    text: "Vemos cómo funciona hoy tu negocio de verdad.",
  },
  {
    icon: AlertTriangle,
    title: "Fugas principales",
    text: "Detectamos dónde pierdes tiempo, ventas o margen.",
  },
  {
    icon: Target,
    title: "Prioridad nº1",
    text: "Elegimos el primer punto que merece atención.",
  },
  {
    icon: FlaskConical,
    title: "Experimento 7 días",
    text: "Diseñamos una prueba barata para validar mejora.",
  },
  {
    icon: Cpu,
    title: "Automatización si procede",
    text: "Solo automatizamos lo que ya tiene sentido.",
  },
];

const WhatIs = () => {
  return (
    <section
      id="que-es"
      data-testid="whatis-section"
      className="et-section relative"
    >
      <div className="et-container relative z-10">
        <div className="grid lg:grid-cols-12 gap-8 items-end">
          <Reveal className="lg:col-span-6">
            <div className="et-eyebrow">El producto</div>
            <h2 className="mt-5 text-3xl sm:text-4xl lg:text-5xl font-bold leading-[1.05] text-white et-text-balance">
              Qué es la{" "}
              <span className="et-text-gold">Radiografía de Negocio.</span>
            </h2>
          </Reveal>

          <Reveal delay={0.1} className="lg:col-span-6">
            <p className="text-base md:text-lg text-[#f5f2ea]/90 leading-relaxed">
              Es un diagnóstico práctico para ver dónde se te escapa el negocio:
              tiempo, ventas, margen, seguimiento, procesos y herramientas. No
              es un informe para guardar en una carpeta. Es una herramienta para{" "}
              <span className="text-white font-semibold">
                decidir qué hacer primero.
              </span>
            </p>
          </Reveal>
        </div>

        <div className="mt-10 md:mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {CARDS.map((c, i) => (
            <Reveal key={c.title} delay={0.05 + i * 0.06}>
              <div
                className="et-card h-full flex flex-col"
                data-testid={`whatis-card-${i}`}
              >
                <div className="flex items-center justify-between mb-5">
                  <div
                    className="w-11 h-11 rounded-xl grid place-items-center"
                    style={{
                      background: "rgba(197,160,89,0.1)",
                      border: "1px solid rgba(197,160,89,0.3)",
                    }}
                  >
                    <c.icon className="w-5 h-5 text-[#c5a059]" />
                  </div>
                  <span className="text-[10px] font-mono tracking-[0.2em] text-[#c5a059]/70">
                    0{i + 1}
                  </span>
                </div>
                <h3 className="text-base md:text-lg font-semibold text-white tracking-tight leading-snug">
                  {c.title}
                </h3>
                <p className="mt-2 text-sm md:text-base text-[#f5f2ea]/80 leading-relaxed">
                  {c.text}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhatIs;
